// On phones, force a line break in the original headline. The Advent hero has its own editable headline, so skip it there.
if (window.innerWidth < 700 && !document.querySelector(".advent-hero")) {
    document.querySelector(".pf-lp-01__title").innerHTML = "we know how <br> <span> great coffee </span> should taste"
}

// document.querySelector("#CustomerHubApp").remove();
